import { cva } from '@/styled-system/css';

export const progressStepperBarRecipe = cva({
  base: {
    'position': 'absolute',
    '& .c11n_progress__track': {
      backgroundColor: 'ProgressMeter.Track.default',
    },
    '& .c11n_progress__range': {
      backgroundColor: 'ProgressMeter.Track.active',
    },
  },
  variants: {
    orientation: {
      horizontal: {
        insetBlockStart:
          'calc(({sizes.ProgressMeter.Node.focusRing.default.hover} / 2) - ({sizes.pipe.weight.thickest} / 2))',
        insetInlineStart: 'calc((var(--c11n-step-width) / 2) - {sizes.indicator.xs})',
        width: 'calc((100% - var(--c11n-step-width)) + {sizes.indicator.xs} * 2)',
        height: 'pipe.weight.thickest',
      },
      vertical: {
        'insetBlockStart':
          'calc(({lineHeights.body-sm} - {sizes.indicator.xs} - {sizes.indicator.xs}) / 2)',
        'insetInlineStart':
          'calc(({sizes.ProgressMeter.Node.focusRing.default.hover} / 2) - ({sizes.pipe.weight.thickest} / 2))',
        'width': 'pipe.weight.thickest',
        'height': 'calc(100% * (1 - 1 / var(--c11n-steps)) + {sizes.pipe.weight.thickest})',
        '& .c11n_progress__range': {
          width: '100%',
        },
      },
    },
  },
});
